import React from 'react';

class SortingToolbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleSortChange = this.handleSortChange.bind(this);
  }

  handleSortChange(sortBy, sortDir) {
    this.props.onChange(sortBy, sortDir);
  }

  render() {
    let sortByLabel = '';
    if (this.props.options && this.props.options.length) {
      this.props.options.forEach((option) => {
        if (option.name == this.props.sortBy) {
          sortByLabel = option.label;
        }
      });
    }
    const statusMessage = sortByLabel + ' ' + this.props.sortDir;

    let sortOptions = [];
    if (this.props.options !== undefined && this.props.options.length) {
      sortOptions = this.props.options.map((option) => {
        return <option value={option.name}>{option.label}</option>;
      });
    }

    return (
      <div className="container mb-4" style={{backgroundColor: '#dedede', paddingTop: '0.75rem', paddingBottom: '0.75rem', border: '1px solid #d6d6d6', borderRadius: '0.3rem'}}>
        <div className="row">
          <div className="col-12">
            <h3><i className="fa fa-sort" /> Ordina <small>({statusMessage || 'nessun filtro'})</small></h3>

            {
              this.props.options !== undefined && this.props.options.length ? (
                <div className="mt-3">
                  <label>Ordina per:</label>
                  <div className="clearfix" />

                  <div className="float-left">
                    <select className="form-control" value={this.props.sortBy} onChange={(e) => {
                      const sortBy = e.currentTarget.value;

                      this.handleSortChange(sortBy, this.props.sortDir);
                    }}>
                      {sortOptions}
                    </select>
                  </div>
                  <div className="btn-group float-left ml-2">
                    {
                      ['ASC', 'DESC'].map((sortDir) => {
                        return (
                          <button
                            className={'btn ' + (this.props.sortDir == sortDir ? 'btn-primary' : 'btn-secondary')}
                            onClick={(e) => {this.handleSortChange(this.props.sortBy, sortDir);}}
                          >
                            <i className={'fa mr-1 ' + (sortDir == 'ASC' ? 'fa-arrow-up' : 'fa-arrow-down')} /> {sortDir}
                          </button>
                        );
                      })
                    }
                  </div>
                </div>
              ) : 'no options'
            }
          </div>
        </div>
      </div>
    );
  }
}

export default SortingToolbar;


// WEBPACK FOOTER //
// ./src/components/shared/SortingToolbar.js